import { render, staticRenderFns } from "./shopNameCell.vue?vue&type=template&id=55b179d8&scoped=true"
import script from "./shopNameCell.vue?vue&type=script&lang=js"
export * from "./shopNameCell.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55b179d8",
  null
  
)

export default component.exports